import React, { useState } from "react";
import InputText from "./InputFilter";
import Container from "../../Layout/Container";
import ContentBlock from "../../Layout/ContentBlock";
import FilterMenu from "../../Layout/FilterMenu";
import TableFilterBox from "../../common/TableFilterBox";
import ContentValidation from "../../common/ContentValidation";
import { ButtonInfo, SelectForm } from "../../common/Buttons";
import {
  getOrders,
  getOrder,
  createInvoices,
  updateSerialNumber,
  setOrderSettings,
  getOrderInitials,
  callGenerateShipmentXlsx,
} from "../../../redux/Actions/orderAction";
import { setPickupAddressesOptions } from "../../../redux/Actions/options_action";
import { orderBulkByIds } from "../../../redux/Actions/bulk_shipment_action";
import { getCommentStateOption } from "../../../redux/Actions/comment_StateAction";
import { postTrRequests } from "../../../redux/Actions/tr_requests_action";
import { connect, useDispatch } from "react-redux";
import Pagination from "../../Dashboard/items/Pagination";
import { AlertSuccess, AlertError } from "../../common/Alerts";
import RangePickerComp from "../../common/RangePickerComp";
import moment from "moment";
import { Select, Checkbox, Switch, Spin, Modal, Tooltip, Dropdown } from "antd";
import RegularModal from "./Modals/RegularModalsOrders";
import {
  antdMessageError,
  exportDocument,
  formatDatePlus,
  prettyDateFormat,
  uniqueArray,
} from "../../../helpers/Utils";
import { AiFillInfoCircle } from "react-icons/ai";

const { Option, OptGroup } = Select;
import {
  resetOrdersFilter,
  setOrdersFilters,
  valueOrdersFilter,
  valueMultiOrdersFilter,
} from "../../../redux/Actions/filtersAction";
import { orders_clean } from "../../../redux/Reducers/filtersReducer";
import ScrollYComponent from "./items/ScrollYComponent";
import OrderBulkAction from "./items/OrderBulkAction";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import {
  have_product_reference,
  onlyFiOrders,
  getAmazonValues,
  sortOrderShops,
  handleAmazonGroup,
  addAmazonGroupIfAll,
} from "../../../helpers/OrdersFunctionsGlobal";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { log } from "../../../helpers/log";
import OrderTable from "./items/OrderTable";
import { getCarriersActive } from "../../../redux/Actions/carrier_action";
import { getPaymentsTypesOptions } from "../../../redux/Actions/paymentAction";
import { getStatusesOptions } from "../../../redux/Actions/statusesAction";
import { setCountriesOptions } from "../../../redux/Actions/options_action";
import ModalBulkActionPreviewHistory from "./Modals/ModalBulkActionPreviewHistory";
import { Label, SelectInput } from "../../globals";
import { shipment_types_options } from "../../../helpers/GlobalOptions";
import { exportedDocumentAction } from "../../../redux/Actions/exportedDocumentAction";
import useFetch from "../../../hooks/useFetch";
import { IconEye, IconEyeInvisible } from "../../Layout/Icons";
import { AnimatePresence, motion } from "framer-motion";
import { getLocalStorage, setLocalStorage } from "../../../utils/localstorage";
import Axios from "axios";
import { InputSwitchComponent } from "../../globals";
import { DebounceSelect } from "../../common";
import OrdersAlertsModal from "../../common/OrdersAlertsModal";
import { ALERT_ROLES } from "../../Alerts/alertHelpers";

const { confirm } = Modal;

// How to read back each key that onFilter pushes into the query string (see
// `filterSearchParamsUrl` below). Without this the URL was write-only: every
// filter was written to it but only customer_email was ever parsed, so editing
// e.g. ?id= in the address bar reloaded the *previous* filter out of
// localStorage and then rewrote the URL back to it.
//
// comment_state_* is deliberately absent - rebuilding it needs the comment
// option tree, which is only fetched after mount.
const urlDateRange = (value) => {
  const [from = "", to = ""] = value.split(",");
  return [from, to];
};

// delivery holds carrier group ids while carrierGroups is loaded and carrier
// names otherwise, and both are compared with ===, so numeric parts have to come
// back as numbers.
const urlMixedList = (value) =>
  value
    .split(",")
    .map((part) => (part !== "" && !isNaN(part) ? Number(part) : part));

const urlFlag = (value) => value === "1";

const URL_FILTER_DECODERS = {
  id: (v) => v,
  client: (v) => v,
  customer_email_exact: (v) => v,
  payer: (v) => v,
  order_row: (v) => v,
  comment: (v) => v,
  ean: (v) => v,
  at_the_store: (v) => v,
  invoice_email_state: (v) => v,
  date: urlDateRange,
  client_delivery_date: urlDateRange,
  shipout_deadline: urlDateRange,
  delivery: urlMixedList,
  assigned_bills_check: urlFlag,
  serialNumber_check: urlFlag,
  with_errors_check: urlFlag,
  stuck_in_delivery: urlFlag,
  not_picked_up: urlFlag,
};

class AcceptedOrders extends React.Component {
  constructor() {
    super();
    this.state = {
      checkedAll: false,
      hidden_filters: false,
      layoutOfTable: [],
      carriers: [],
      payment_types: [],
      statuses: [],
      comment_state: [],
      comments_state_all: [],

      orders_checked: [],
      order_rows_checked: [],
      orders_checked_full: [],
      supplyings_checked: [],
      order_row_type: "Supply",
      reload_for_bulk_shipments: 1,
      modal_bulk_action_preview: false,
      isAlertModalVisible: false,
      alerts: [],
      orderAlerts: [],
      alertRules: [],
      isAlertsLoading: true,
      showAlertMessage: true,
    };
    this.modalRef = React.createRef();
    // Set when a Search/filter is requested while a fetch is still in flight,
    // so it can be applied the moment loading finishes (see componentDidUpdate).
    this.pendingFilter = false;
  }

  componentDidMount() {
    this.fetchData();
    getLocalStorage("orders_hidden_filters").then((hidden_filters) => {
      if (typeof hidden_filters == "boolean") {
        this.setState({
          hidden_filters,
        });
      }
    });
    // Pass the resolved set straight into onFilter - the dispatch above has not
    // reached this.props yet (see applyUrlFilters).
    const urlFilter = this.applyUrlFilters();
    // action
    if (this.props.location.search) {
      this.onFilter(urlFilter);
    } else if (!this.props.match.params.action) {
      this.onFilter(urlFilter);
    } else {
      this.onEdit("test", this.props.match.params.action);
      this.onFilter(urlFilter);
      this.props.history.push("/orders");
    }
    this.props.setPickupAddressesOptions();
    getCommentStateOption().then((res) => {
      if (res.data) {
        let commentAll = [];
        let comment_ka = [
          { title: "KA komentaras", name: "-Be komentarų-", id: "ka_0" },
        ];
        let comment_management = [
          { title: "Vadybos komentaras", name: "-Be komentarų-", id: "vd_0" },
        ];
        let comment_logistic = [
          {
            title: "Logistikos komentaras",
            name: "-Be komentarų-",
            id: "log_0",
          },
        ];

        res.data.forEach((item) => {
          let newObj = {
            label: item.name,
            name: item.name,
            value: item.id,
            color: item.color,
            ordering: item.ordering,
            identifier: item.identifier,
            comment_type: item.comment_type,
            show_date: item.show_date,
          };
          commentAll.push(newObj);
          let cmst = item.comment_type;
          if (cmst == "comment_ka") {
            comment_ka.push(item);
          } else if (cmst == "comment_management") {
            if (onlyFiOrders(this.props.user.id)) return true;
            comment_management.push(item);
          } else {
            comment_logistic.push(item);
          }
        });
        const return_comment_state = [
          {
            title: "KA komentaras",
            children: comment_ka,
          },
          {
            title: "Vadybos komentaras",
            children: comment_management,
          },
          {
            title: "Logistikos komentaras",
            children: comment_logistic,
          },
        ];
        this.setState({
          comment_state: return_comment_state.filter(
            (option) => option.children.length > 1
          ),
          comments_state_all: commentAll,
        });
      }
    });
    this.props.getOrderInitials();
    this.layoutOfTableLocalStorage();
    getCarriersActive().then((carriers) => this.setState({ carriers }));
    getPaymentsTypesOptions().then(({ data: payment_types }) =>
      this.setState({ payment_types })
    );
    getStatusesOptions().then((statuses) => this.setState({ statuses }));
    this.fetchOrderAlerts();
    this.fetchAlertRules();

  }

  // Reads the filters back out of the query string. When the URL carries any of
  // them it defines the *complete* filter set, so a link reproduces exactly the
  // filter it names instead of inheriting whatever was last used in this
  // browser; returns null when it carries none, leaving the stored filters alone.
  //
  // The resolved set is returned as well as dispatched because componentDidMount
  // calls onFilter() in the same tick, and this.props cannot update until React
  // re-renders - onFilter would otherwise build the query from the pre-dispatch
  // snapshot. That is why the URL email filter never applied on a cold load
  // either.
  applyUrlFilters = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const urlValues = {};

    Object.keys(URL_FILTER_DECODERS).forEach((key) => {
      if (!searchParams.has(key)) return;
      urlValues[key] = URL_FILTER_DECODERS[key](searchParams.get(key));
    });

    // legacy alias, still used by links coming from other systems
    if (
      !searchParams.has("customer_email_exact") &&
      searchParams.has("customer_email")
    ) {
      urlValues.customer_email_exact = searchParams.get("customer_email");
    }

    if (Object.keys(urlValues).length === 0) return null;

    const resolved = {
      ...orders_clean,
      // The status / category / supplier filters live on user_setting and are
      // applied server-side; they are not in the URL, and clearing them here
      // would leave the controls disagreeing with the query the server runs.
      statusFilter: this.props.orderFilter.statusFilter,
      categoryFilter: this.props.orderFilter.categoryFilter,
      user_suppliers: this.props.orderFilter.user_suppliers,
      ...urlValues,
    };

    this.props.setOrdersFilters(resolved);
    return resolved;
  };

  // Filter id arrays arrive from redux freshly rebuilt even when nothing changed
  // (the auth boot re-dispatches the user_setting mirror via valueMultiOrdersFilter),
  // so comparing references here refired getOrders + fetchOrderAlerts on every
  // page load - the orders list was fetched twice per visit. Compare contents;
  // ids may arrive as strings from modals and numbers from the JWT, hence String().
  sameFilterIds = (a, b) => {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((v, i) => String(v) === String(sortedB[i]));
  };

  uniqueOrdersById = (orders = []) => {
    const seen = new Set();
    return orders.filter((order) => {
      const orderId = order?.id;
      if (!orderId || seen.has(orderId)) return false;
      seen.add(orderId);
      return true;
    });
  };

  componentDidUpdate(prevProps) {
    if (!this.sameFilterIds(prevProps.orderFilter.categoryFilter, this.props.orderFilter.categoryFilter)) {
      this.fetchOrderAlerts();
      this.props.getOrders();
    }
    if (
      prevProps.orderFilter.alerts !== this.props.orderFilter.alerts ||
      prevProps.orderFilter.alert_ids !== this.props.orderFilter.alert_ids
    ) {
      this.onFilter();
    }
    // A Search press issued while a fetch was in flight was deferred; apply it
    // as soon as that fetch finishes so the user never has to press twice.
    if (
      this.pendingFilter &&
      prevProps.loading_orders &&
      !this.props.loading_orders
    ) {
      this.pendingFilter = false;
      this.onFilter();
    }
  }

  fetchOrderAlerts = async () => {
    try {
      this.setState({ isAlertsLoading: true });
      const response = await Axios.get(
        "/api/v1/order_alerts?page=1&per_page=9999999"
      );
      this.setState({ orderAlerts: response.data.data });
      this.setState({ isAlertsLoading: false });
      if (response.data.data?.length > 0) {
        setTimeout(() => {
          this.setState({ showAlertMessage: false });
        }, 7000);
      }
    } catch (error) {
      console.error("Error fetching order alerts:", error);
      this.setState({ isAlertsLoading: false });
    }
  };

  fetchAlertRules = () => {
    Axios.get("/api/v1/alerts?page=1&per_page=500")
      .then((response) => {
        this.setState({ alertRules: response.data.data || [] });
      })
      .catch(() => {});
  };

  toggleAlertsFilter = () => {
    const enabled = !this.props.orderFilter.alerts;
    this.props.valueMultiOrdersFilter({
      alerts: enabled,
      alert_ids: enabled ? this.props.orderFilter.alert_ids || [] : [],
    });
  };

  fetchData = () => {
    this.setState({ loadingData: true });

    Axios.get(`/api/v1/carrier_groups`)
      .then((response) => {
        const transformedData = response.data.data.map((item) => ({
          ...item,
          value: item.id,
          label: item.title,
        }));

        this.setState({ carrierGroups: transformedData, loadingData: false });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        this.setState({ loadingData: false });
      });

    Axios.get(`/api/v1/payment_groups`)
      .then((response) => {
        const transformedData = response.data.data.map((item) => ({
          ...item,
          value: item.id,
          label: item.title,
        }));

        this.setState({ paymentGroups: transformedData, loadingData: false });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        this.setState({ loadingData: false });
      });

    Axios.get(`/api/v1/status_groups`)
      .then((response) => {
        const transformedData = response.data.data.map((item) => ({
          ...item,
          value: item.id,
          label: item.title,
        }));

        this.setState({ statusGroups: transformedData, loadingData: false });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        this.setState({ loadingData: false });
      });
  };

  layoutOfTableLocalStorage = () => {
    const defaultStorage = [
      "Užsakymo data",
      "Eksp",
      "Order numeris",
      "Klientas",
      "Suma",
      "Prekes",
      "Likučiai",
      "DOCS",
      "Mokėjimo būdas",
      "Pristatymas",
      "Statusas",
      "KA komentarai",
      "Vadyba",
      "Logistika",
    ];
    const getLocalStorage = Array.isArray(
      JSON.parse(localStorage.getItem("orderTable"))
    )
      ? JSON.parse(localStorage.getItem("orderTable"))
      : defaultStorage;

    this.setState({
      layoutOfTable: getLocalStorage,
    });
  };

  reloadOrders = () => {
    this.props.getOrders();
  };

  openAlertModal = (alerts) => {
    this.setState({ isAlertModalVisible: true, alerts });
  };

  closeAlertModal = () => {
    this.setState({ isAlertModalVisible: false, alerts: [] });
  };

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return "";
  }

  setGetParam(key, value) {
    if (history.pushState) {
      let params = new URLSearchParams(window.location.search);
      // Drop the key only when the whole array is empty. Testing value[0] alone
      // dropped open-ended ranges such as ["", "2026-06-01"] ("until X" with no
      // "from"), so a to-only date filter never reached the URL - and now that
      // the URL is authoritative on load, reloading such a link would clear it.
      if (
        Array.isArray(value) &&
        value.every((part) => part === "" || part === undefined)
      ) {
        params.delete(key);
      } else if (value !== undefined && value.length > 0) {
        params.set(key, value);
      } else {
        params.delete(key);
      }

      var newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        params.toString();
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  }

  onEdit = (_, id) => {
    this.props.getOrder(id);
    this.modalRef.current.openModal("OrderShowModal");
  };

  onCreate = () => {
    this.modalRef.current.openModal("OrderCreateModal");
  };

  setPagination = (page) => {
    this.props.setOrderSettings({
      page,
    });
  };
  setPageCount = (page_count) => {
    this.props.setOrderSettings({
      page_count,
      page: 1,
    });
  };

  tableColumnSelector = (selectedItems) => {
    this.setState({
      layoutOfTable: selectedItems,
    });
  };

  filterChange = async (e, date) => {
    if (date === "delivery") {
      let filters = {
        [date]: e,
      };
      const includesStore = e.includes("Atsiėmimas parduotuvėje");
      if (!includesStore) {
        filters.at_the_store = undefined;
      }
      await this.props.valueMultiOrdersFilter(filters);
    } else if (date) {
      await this.props.valueOrdersFilter({ name: [date], value: e });
    } else {
      this.props.valueOrdersFilter({
        name: e.target.name,
        value: e.target.value,
      });
    }
  };

  onFilter = (filterOverride) => {
    if (this.props.loading_orders) {
      // A request is already in flight. Queue this press and let
      // componentDidUpdate re-run onFilter the instant loading finishes,
      // instead of blindly polling every second (which made the first
      // press feel lost, so users pressed Search twice).
      // No need to carry filterOverride across: applyUrlFilters has already
      // dispatched it, so by the time componentDidUpdate re-runs onFilter the
      // props hold those values.
      this.pendingFilter = true;
      return;
    }
    this.pendingFilter = false;
    // filterOverride bridges the one tick in componentDidMount where the URL
    // filters are in the store but not yet in this.props.
    const orderFilter = filterOverride || this.props.orderFilter;
    let filterParams = [];
    if (orderFilter.order_shops !== undefined) {
      orderFilter.order_shops.forEach((each) => {
        filterParams.push(`&q[order_shop_id_in][]=${each}`);
      });
    }

    if (
      !onlyFiOrders(this.props.user.id) &&
      orderFilter.supp_date[0].length > 0
    ) {
      filterParams.push(
        `&q[order_rows_supplyings_date_gteq]=${orderFilter.supp_date[0]}`
      );
      if (orderFilter.without_shipping) {
        filterParams.push(`&q[order_rows_shipment_order_rows_id_blank]=1`);
      }
      if (orderFilter.carrying) {
        filterParams.push(`&after[carrying]=1`);
      }
    }
    if (
      !onlyFiOrders(this.props.user.id) &&
      orderFilter.supp_date[1].length > 0
    ) {
      filterParams.push(
        `&q[order_rows_supplyings_date_lteq]=${orderFilter.supp_date[1]}`
      );
    }

    if (orderFilter.invoice_email_state) {
      filterParams.push(
        `&q[invoice_email_state_eq]=${orderFilter.invoice_email_state}`
      );
    }

    if (orderFilter.id.length > 0)
      filterParams.push(`&q[id_order_eq]=${orderFilter.id}`);
    if (orderFilter.customer_email_exact?.length > 0) {
      filterParams.push(
        `&q[customer_email_eq]=${encodeURIComponent(
          orderFilter.customer_email_exact.trim()
        )}`
      );
    }
    if (orderFilter.client.length > 0) {
      filterParams.push(
        `&q[customer_fulltext]=${encodeURIComponent(
          orderFilter.client.trim()
        )}`
      );
    }
    if (orderFilter.total_price_from) {
      filterParams.push(
        `&q[total_price_gteq_any]=${orderFilter.total_price_from}`
      );
    }
    if (orderFilter?.reverse_vat) {
      filterParams.push(`&q[reverse_vat]=1`);
    }
    if (orderFilter?.has_stock) {
      filterParams.push(`&q[has_stock]=1`);
    }
    if (orderFilter?.auto_launch_exceptions) {
      filterParams.push(`&q[auto_launch_exceptions]=1`);
    }
    if (orderFilter?.blacklisted) {
      filterParams.push(`&q[customer_blacklisted_at_not_null]=1`);
    }
    if (orderFilter.total_price_to) {
      filterParams.push(
        `&q[total_price_lteq_any]=${orderFilter.total_price_to}`
      );
    }
    if (orderFilter?.payment_status) {
      if (this.state.statusGroups?.length) {
        const selectedStatus = this.state.statusGroups.find(
          (status) => status.id === orderFilter.payment_status
        );
        if (selectedStatus) {
          const matchingStatusIds = selectedStatus.status_ids

          matchingStatusIds.map((statusId) => {
            filterParams.push(`&q[status_id_in][]=${statusId}`);
          });
        }
        console.log("selectedStatus:", selectedStatus);
      } else {
        const selectedStatus = this.state.statuses.find(
          (status) => status.value === orderFilter.payment_status
        );

        if (selectedStatus) {
          const matchingStatusIds = this.state.statuses
            .filter((status) => status.title === selectedStatus.title)
            .map((status) => status.value);

          matchingStatusIds.map((statusId) => {
            filterParams.push(`&q[status_id_in][]=${statusId}`);
          });
        }
      }
    }
    if (orderFilter?.supplier_id) {
      if (orderFilter.supplier_is_primary) {
        filterParams.push(
          `&q[order_rows_product_info_main_supplier_id_eq]=${orderFilter.supplier_id.value}`
        );
      } else {
        filterParams.push(
          `&q[order_rows_product_info_product_suppliers_available_quantity_gt]=0`
        );
      }
      filterParams.push(
        `&q[order_rows_product_info_product_suppliers_supplier_id_eq]=${orderFilter.supplier_id.value}`
      );
    }
    if (orderFilter?.product_qty_in_order) {
      filterParams.push(
        `&q[product_qty]=${orderFilter.product_qty_in_order}`
      );
    }
    if (orderFilter?.no_goods_supply) {
      filterParams.push(
        `&q[no_supply]=${orderFilter.no_goods_supply}`
      );
    }

    if (orderFilter.payer?.length > 0) {
      filterParams.push(
        `&q[billing_address_fulltext]=${encodeURIComponent(
          orderFilter.payer.trim()
        )}`
      );
    }
    if (
      orderFilter.delivery &&
      orderFilter.delivery.includes("Atsiėmimas parduotuvėje") &&
      orderFilter.at_the_store &&
      orderFilter.at_the_store !== "Visos"
    ) {
      filterParams.push(
        `&q[shipping_address_street_cont_any]=${orderFilter.at_the_store}`
      );
    }

    if (orderFilter.created) {
      filterParams.push(
        `&q[created_cont_any]=${orderFilter.created}`
      );
    }
    if (orderFilter?.ean?.length > 0) {
      filterParams.push(
        `&q[order_rows_product_info_ean_cont_any]=${orderFilter.ean}`
      );
    }
    if (orderFilter.date[0].length > 0)
      filterParams.push(
        `&q[order_date_gteq]=${orderFilter.date[0]}`
      );

    if (orderFilter.date[1].length > 0) {
      filterParams.push(
        `&q[order_date_lt]=${formatDatePlus(orderFilter.date[1])}`
      );
    }
    if (orderFilter.client_delivery_date?.[0]?.length > 0) {
      filterParams.push(
        `&q[order_rows_delivery_date_gteq]=${orderFilter.client_delivery_date[0]}`
      );
    }
    if (orderFilter.client_delivery_date?.[1]?.length > 0) {
      filterParams.push(
        `&q[order_rows_delivery_date_lteq]=${orderFilter.client_delivery_date[1]}`
      );
    }
    if (orderFilter.shipout_deadline?.[0]?.length > 0) {
      filterParams.push(
        `&q[shipout_deadline_gteq]=${orderFilter.shipout_deadline[0]}`
      );
    }
    if (orderFilter.shipout_deadline?.[1]?.length > 0) {
      filterParams.push(
        `&q[shipout_deadline_lteq]=${orderFilter.shipout_deadline[1]}`
      );
    }
    if (orderFilter.gift_code) {
      filterParams.push(`&q[order_cart_rules_title_cont]=${orderFilter.gift_code}`);
    }
    if (orderFilter.urgents)
      filterParams.push(`&q[urgent_true]=true`);

    if (orderFilter.alerts) {
      filterParams.push(`&q[has_alerts]=1`);
      (orderFilter.alert_ids || []).forEach((alert_id) => {
        filterParams.push(`&q[alert_ids][]=${alert_id}`);
      });
    }

    if (orderFilter.vips)
      filterParams.push(`&q[vip_true]=true`);

    if (orderFilter.ship_api_errors) {
      filterParams.push(`&q[shipments_api_errors_present]=1`);
    }
    if (orderFilter.invoice_api_errors) {
      filterParams.push(`&q[order_invoices_api_errors_present]=1`);
    }

    if (
      !!orderFilter.order_row &&
      orderFilter.order_row.length > 0
    ) {
      filterParams.push(
        `&q[order_rows_product_name_or_order_rows_product_reference_or_order_rows_product_upc_cont]=${orderFilter.order_row}`
      );
    }

    if (this.state?.paymentGroups?.length > 0) {
      const moduleNames = [];

      orderFilter.payment?.forEach?.((paymentGroupId) => {
        const matchingGroup = this.state.paymentGroups?.find?.(
          (group) => group.id === paymentGroupId
        );
        if (matchingGroup) {
          const groupModuleNames =
            matchingGroup.payments?.map((p) => p.module_name) || [];
          moduleNames.push(...groupModuleNames);
        }
      });

      moduleNames?.forEach?.((moduleName) => {
        filterParams.push(`&q[payment_module_in][]=${moduleName}`);
      });
    } else if (orderFilter.payment !== undefined) {
      if (orderFilter.payment?.length > 0)
        orderFilter?.payment?.forEach?.((id) => {
          filterParams.push(`&q[payment_in][]=${id}`);
        });
    }

    if (orderFilter.payment_reference)
      filterParams.push(
        `&q[payments_reference_cont]=${orderFilter.payment_reference}`
      );

    if (this.state.carrierGroups !== undefined) {
      const carrierIds = [];

      orderFilter.delivery?.forEach?.((deliveryId) => {
        const matchingGroup = this.state.carrierGroups?.find?.(
          (group) => group.id === deliveryId
        );
        if (matchingGroup) {
          carrierIds.push(...matchingGroup.carrier_ids);
        }
      });

      carrierIds?.forEach?.((id) => {
        filterParams.push(`&q[carrier_id_in][]=${id}`);
      });
    } else if (orderFilter.delivery !== undefined) {
      orderFilter.delivery.forEach((each) => {
        filterParams.push(`&q[carrier_name_in][]=${each}`);
      });
    }

    if (orderFilter.comment.length > 0) {
      orderFilter.comment.split(" ").forEach((item) => {
        filterParams.push(
          `&q[comments_body_or_comments_user_title_cont]=${item}`
        );
      });
    }

    // Serialnumber order_rows
    if (orderFilter.serialNumber_check) {
      const filterSerialNumberSwitch =
        orderFilter.serialNumber_switch;
      const filterParramString = `&q[order_rows_required_serial_number_true]=${filterSerialNumberSwitch}&q[order_rows_serial_number_present]=${filterSerialNumberSwitch
        ? !filterSerialNumberSwitch
        : filterSerialNumberSwitch
        }`;
      filterParams.push(filterParramString);
    }

    // Asigned Bills
    if (orderFilter.assigned_bills_check) {
      filterParams.push(
        `&q[assigned_bills_true]=${orderFilter.assigned_bills_switch}`
      );
    }

    // Shipments with api errors
    if (orderFilter.with_errors_check) {
      filterParams.push(`&q[shipments_api_errors_present]=1`);
    }
    if (orderFilter.with_tax_free) {
      filterParams.push(`&q[tax_free_declarations_tax_free_events_id_null]=0`);
    }

    if (orderFilter.stuck_in_delivery) {
      filterParams.push(`&stuck_in_delivery=1`);
    }

    if (orderFilter.not_picked_up) {
      filterParams.push(`&not_picked_up=1`);
    }
    if (orderFilter.shipments_created_at) {
      if (
        orderFilter.shipments_created_at[0] &&
        orderFilter.shipments_created_at[0].length > 0
      ) {
        filterParams.push(
          `&q[shipments_created_at_gteq]=${orderFilter.shipments_created_at[0]}`
        );
        filterParams.push(`&q[shipments_api_errors_null]=1`);
        if (orderFilter.shipment_type) {
          filterParams.push(
            `&q[shipments_shipment_type_eq]=${orderFilter.shipment_type}`
          );
        }
      }
      if (
        orderFilter.shipments_created_at[1] &&
        orderFilter.shipments_created_at[1].length > 0
      ) {
        filterParams.push(
          `&q[shipments_created_at_lteq]=${formatDatePlus(
            orderFilter.shipments_created_at[1]
          )}`
        );
      }
    }
    let filterSearchParamsUrl = [
      {
        key: "id",
        value: orderFilter.id,
      },
      {
        key: "client",
        value: orderFilter.client,
      },
      {
        key: "customer_email_exact",
        value: orderFilter.customer_email_exact,
      },
      {
        key: "payer",
        value: orderFilter.payer,
      },
      {
        key: "date",
        value: orderFilter.date,
      },
      {
        key: "client_delivery_date",
        value: orderFilter.client_delivery_date,
      },
      {
        key: "shipout_deadline",
        value: orderFilter.shipout_deadline,
      },
      // {
      //   key: "payment",
      //   value: orderFilter.payment,
      // },
      {
        key: "order_row",
        value: orderFilter.order_row,
      },
      {
        key: "delivery",
        value: orderFilter.delivery,
      },
      {
        key: "comment",
        value: orderFilter.comment,
      },
      {
        key: "ean",
        value: orderFilter.ean,
      },
      {
        key: "assigned_bills_check",
        value: orderFilter.assigned_bills_check ? "1" : "",
      },
      {
        key: "serialNumber_check",
        value: orderFilter.serialNumber_check ? "1" : "",
      },
      {
        key: "with_errors_check",
        value: orderFilter.with_errors_check ? "1" : "",
      },
      {
        key: "stuck_in_delivery",
        value: orderFilter.stuck_in_delivery ? "1" : "",
      },
      {
        key: "not_picked_up",
        value: orderFilter.not_picked_up ? "1" : "",
      },
      {
        key: "at_the_store",
        value:
          orderFilter.delivery &&
            orderFilter.delivery.includes("Atsiėmimas parduotuvėje") &&
            ![undefined, "Visos"].includes(orderFilter.at_the_store)
            ? orderFilter.at_the_store
            : "",
      },
      {
        key: "invoice_email_state",
        value: orderFilter.invoice_email_state,
      },
      // {
      //   key: "comment_state",
      //   value: orderFilter.comment_state.map((item) => item.value),
      // },
    ];
    if (orderFilter.comment_state.length > 0) {
      let search_ka = [];
      let search_log = [];
      let search_man = [];
      orderFilter.comment_state.forEach((item) => {
        if (item.children2 == "KA komentaras") {
          if (item.value == "ka_0") {
            filterParams.push(`&q[comment_ka_id_null]=true`);
          } else {
            filterParams.push(`&q[comment_ka_id_in][]=${item.value}`);
          }
          search_ka.push(item.value);
        } else if (item.children2 == "Logistikos komentaras") {
          if (item.value == "log_0") {
            filterParams.push(`&q[comment_logistic_id_null]=true`);
          } else {
            filterParams.push(`&q[comment_logistic_id_in][]=${item.value}`);
          }
          search_log.push(item.value);
        } else if (item.children2 == "Vadybos komentaras") {
          if (item.value == "vd_0") {
            filterParams.push(`&q[comment_management_id_null]=true`);
          } else {
            filterParams.push(`&q[comment_management_id_in][]=${item.value}`);
          }
          search_man.push(item.value);
        }
      });
      filterSearchParamsUrl.push({
        key: "comment_state_ka",
        value: search_ka,
      });
      filterSearchParamsUrl.push({
        key: "comment_state_log",
        value: search_log,
      });
      filterSearchParamsUrl.push({
        key: "comment_state_man",
        value: search_man,
      });
    } else {
      filterSearchParamsUrl.push({
        key: "comment_state_ka",
        value: [],
      });
      filterSearchParamsUrl.push({
        key: "comment_state_log",
        value: [],
      });
      filterSearchParamsUrl.push({
        key: "comment_state_man",
        value: [],
      });
    }
    filterSearchParamsUrl.forEach((item) => {
      this.setGetParam(item.key, item.value);
    });

    this.props.setOrderSettings({
      params_filter: filterParams.join(""),
      page: 1,
    });
    this.clearChecked();
  };

  handleKeyDown = (e) => {
    if (e.key == "Enter") {
      this.onFilter();
    }
  };
  getDateFormat = (date) => {
    var d = moment(date);
    return date && d.isValid() ? d : "";
  };

  clearChecked = () => {
    this.setState(
      {
        orders_checked: [],
        orders_checked_full: [],
        supplyings_checked: [],
        order_rows_checked: [],
      },
      () => this.bulkDataSetter()
    );
  };

  clearFilter = async () => {
    this.clearChecked();
    await this.props.resetOrdersFilter();
    // await this.onFilter();
  };

  renderCustomButton = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-sm btn-primary float-left ml-3"
          onClick={() => this.onCreate()}
        >
          {"New order"}
        </button>
        {!onlyFiOrders(this.props.user.id) && (
          <div className="float-left ml-1">
            <OrderBulkAction
              checkedArray={this.state.orders_checked}
              checkedArrayFull={this.state.orders_checked_full}
              comments_state={this.state.comments_state_all}
              order_rows_accepted={this.state.order_rows_checked}
              unCheck={(type, check_data) => {
                if (type == "orders") {
                  this.setState({
                    orders_checked: check_data,
                  });
                } else if (type == "modal_bulk_action_preview") {
                  this.setState({
                    modal_bulk_action_preview: true,
                  });
                } else {
                  this.setState({
                    order_rows_checked: check_data,
                  });
                }
              }}
              modalRef={this.modalRef.current}
            />
          </div>
        )}
        {/*  */}
        <ExportDropdown
          cleanUp={() =>
            this.setState({
              orders_checked: [],
              supplyings_checked: [],
              orders_checked: [],
            })
          }
          orderFilter={this.props.orderFilter}
          user={this.props.user}
          settings={this.props.settings}
          orders_checked={this.state.orders_checked}
          supplyings_checked={this.state.supplyings_checked}
          total_amount={this.props.total_amount}
        />
        {!onlyFiOrders(this.props.user.id) && (
          <>
            <div className="dropdown">
              <button
                className="btn btn-sm btn-dark float-right mr-1 dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Create invoices
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <button
                  className="dropdown-item"
                  onClick={() => this.createInvoices("selected")}
                >
                  Selected orders
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => this.createInvoices("all")}
                >
                  All orders
                </button>
              </div>
            </div>
          </>
        )}

        <ButtonInfo
          className={"mr-3"}
          onClick={() =>
            this.setState(
              (prev) => ({
                hidden_filters: !prev.hidden_filters,
              }),
              () =>
                setLocalStorage(
                  "orders_hidden_filters",
                  this.state.hidden_filters
                )
            )
          }
        >
          {this.state.hidden_filters ? (
            <span>
              <IconEye color="#1F1A54" /> Show
            </span>
          ) : (
            <span>
              <IconEyeInvisible color="#1F1A54" /> Hide
            </span>
          )}{" "}
          filter
        </ButtonInfo>
      </>
    );
  };

  createInvoices = (action) => {
    if (action == "selected" && this.state.orders_checked.length == 0) {
      return antdMessageError("Not selected");
    }
    createInvoices(
      action,
      this.state.orders_checked,
      this.state.order_rows_checked,
      this.props.settings.params_filter
    );
  };

  handleSelected = (type, selected_id, default_array = []) => {
    // type: ["order", "order_row", "supplying"]
    let array = default_array;

    if (type == "order") array = this.state.orders_checked;
    else if (type == "order_row") array = this.state.order_rows_checked;
    else if (type == "supplying") array = this.state.supplyings_checked;
    return array.includes(selected_id);
  };

  checkSupplyingsByUserSuppliers = () => {
    const supplying_id = [];
    const order_row_id = [];
    const order_id = [];
    this.props.orders.forEach((order) =>
      order.order_rows.forEach((order_row) =>
        order_row.supplyings.forEach((supplying) => {
          if (!this.props.user.user_suppliers.includes(supplying.supplier_id)) {
            return;
          }
          supplying_id.push(supplying.id);
          order_row_id.push(order_row.id);
          order_id.push(order.id);
        })
      )
    );
    this.setState(
      {
        orders_checked: uniqueArray(order_id),
        order_rows_checked: uniqueArray(order_row_id),
        supplyings_checked: uniqueArray(supplying_id),
      },
      () => this.bulkDataSetter()
    );
  };

  handleCheck = (type, manual) => {
    let orders_checked = [...this.state.orders_checked];
    let orders_checked_full = [...this.state.orders_checked_full];
    let order_rows_checked = [...this.state.order_rows_checked];
    let supplyings_checked = [...this.state.supplyings_checked];

    if (manual.order_id) {
      manual.order_ids = [manual.order_id];
    }

    this.props.orders.forEach((order) => {
      let order_included = this.handleSelected(null, order.id, orders_checked);
      const manual_order_included = manual.order_ids
        ? manual.order_ids.includes(order.id)
        : false;

      if (order_included) {
        if (manual_order_included && !manual.order_row_id) {
          orders_checked = orders_checked.filter(
            (order_id) => order_id !== order.id
          );
          orders_checked_full = orders_checked_full.filter(
            (o) => o.id !== order.id
          );
          order_included = false;
        } else {
          if (manual_order_included) {
            orders_checked.push(order.id);
            orders_checked_full.push(order);
            order_included = true;
          }
        }
      } else {
        if (manual_order_included) {
          orders_checked.push(order.id);
          orders_checked_full.push(order);
          order_included = true;
        }
      }

      order.order_rows
        .filter((order_row) =>
          have_product_reference(order_row.product_reference)
        )
        .forEach((order_row) => {
          let order_row_included = this.handleSelected(
            null,
            order_row.id,
            order_rows_checked
          );

          if (order_row_included || !order_included) {
            if (
              (manual.order_row_id == order_row.id && !manual.supplying_id) ||
              !order_included
            ) {
              order_rows_checked = order_rows_checked.filter(
                (order_row_id) => order_row_id !== order_row.id
              );
              order_row_included = false;
            }
          } else {
            if (manual.order_row_id == order_row.id) {
              order_rows_checked.push(order_row.id);
              order_row_included = true;
            }
            if (!manual.order_row_id && order_included) {
              order_rows_checked.push(order_row.id);
              order_row_included = true;
            }
          }

          order_row.supplyings.forEach((supplying) => {
            let supplying_included = this.handleSelected(
              null,
              supplying.id,
              supplyings_checked
            );

            if (supplying_included || !order_row_included) {
              if (manual.supplying_id == supplying.id || !order_row_included) {
                supplyings_checked = supplyings_checked.filter(
                  (supplying_id) => supplying_id !== supplying.id
                );
              }
            } else {
              if (manual.supplying_id == supplying.id) {
                supplyings_checked.push(supplying.id);
              }
              if (
                !manual.supplying_id &&
                order_row_included &&
                !!this.props.user.user_suppliers?.length &&
                this.props.user.user_suppliers.includes(supplying.supplier_id)
              ) {
                supplyings_checked.push(supplying.id);
                supplying_included = true;
              }
            }
          });
        });
    });

    this.setState(
      {
        orders_checked: uniqueArray(orders_checked),
        orders_checked_full: this.uniqueOrdersById(orders_checked_full),
        order_rows_checked: uniqueArray(order_rows_checked),
        supplyings_checked: uniqueArray(supplyings_checked),
      },
      () => {
        this.bulkDataSetter();
      }
    );
  };

  bulkDataSetter = () => {
    if (this.state.order_row_type !== "Extra services") {
      this.props
        .orderBulkByIds({
          orderIds: [],
          orderRowsIds: [],
          supplyingIds: [],
        })
        .then((res) => {
          this.setState({
            reload_for_bulk_shipments: this.state.reload_for_bulk_shipments + 1,
          });
        });
    } else {
      log("Hook orderbulkbyids");
      this.props
        .orderBulkByIds({
          orderIds: uniqueArray(this.state.orders_checked),
          orderRowsIds: uniqueArray(this.state.order_rows_checked),
          supplyingIds: uniqueArray(this.state.supplyings_checked),
        })
        .then((res) => {
          this.setState({
            reload_for_bulk_shipments: this.state.reload_for_bulk_shipments + 1,
          });
        });
    }
  };

  supplierCodeFetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/suppliers?page=1&per_page=9999999&q[deleted_at_null]=1&q[rivile_supplier_code_null]=0&q[title_or_rivile_supplier_code_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data;
      return (
        valArr.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.rivile_supplier_code} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  render() {
    const customText = (
      <div>
        <span className="filterMenuText first">Total:</span>
        <span className="firstLength">
          {this.props.settings.total_amount &&
            this.props.total_amount == "loading" ? (
            <Spin />
          ) : (
            <span>
              {this.props.settings.total_amount
                ? this.props.total_amount
                : "**********"}{" "}
              {"\u20AC"}
              {this.props.settings.total_amount ? (
                <AiOutlineEyeInvisible
                  color="#D9D9D9"
                  className="text-xl cursor-pointer ml-2"
                  onClick={() =>
                    this.props.setOrderSettings({
                      total_amount: false,
                    })
                  }
                />
              ) : (
                <AiOutlineEye
                  color="#D9D9D9"
                  className="text-xl cursor-pointer ml-2"
                  onClick={() =>
                    this.props.setOrderSettings({
                      total_amount: true,
                    })
                  }
                />
              )}
            </span>
          )}
        </span>
      </div>
    );
    return (
      <>
        <Container
          location={{
            locationName: "Orders",
            locationUrl: this.props.match.url,
          }}
        >
          <>
            <ContentBlock
              extraClass="sticky-top sticky-extra"
              style={{ zIndex: 102 }}
            >
              <div className="d-flex align-items-center">
                <ScrollYComponent />

                <div style={{ width: "100%" }}>
                  <FilterMenu
                    totals={this.props.totals}
                    length={this.props.orders.length}
                    onChangeCountPage={this.setPageCount}
                    text2="Orders"
                    countPage={this.props.settings.page_count}
                    // statusFilter={true}
                    statusFilter={this.modalRef.current}
                    categoryFilterModal={
                      onlyFiOrders(this.props.user.id)
                        ? null
                        : this.modalRef.current
                    }
                    tableLayout={
                      onlyFiOrders(this.props.user.id)
                        ? null
                        : this.modalRef.current
                    }
                    customText={customText}
                  />
                </div>
              </div>
            </ContentBlock>
            <AlertSuccess alertId={"order-s"} />
            <AlertError alertId={"order-e"} />
            <ContentBlock containerClass={"py-1"}>
              <TableFilterBox
                mr={1}
                extraClass="sticky-top"
                style={{
                  top: document.querySelector(".sticky-extra")
                    ? document.querySelector(".sticky-extra").offsetHeight + 7
                    : "50px",
                  zIndex: 10,
                }}
                clearFilter={
                  this.state.hidden_filters ? null : () => this.clearFilter()
                }
                button1={this.renderCustomButton()}
                onFilter={() => this.onFilter()}
                filter={!this.state.hidden_filters}
              >
                <AnimatePresence>
                  {!this.state.hidden_filters && (
                    <motion.div
                      className="filter-grid"
                      initial={{ height: 0 }}
                      animate={{ height: "auto" }}
                      exit={{ height: 0 }}
                      transition={{ duration: 0.2, ease: "easeInOut" }}
                    >
                      <React.Fragment>
                        {!onlyFiOrders(this.props.user.id) && (
                          <div
                            className="px-1"
                            style={{ height: "fit-content" }}
                          >
                            <SelectForm
                              placeholder="Order store"
                              mode="multiple"
                              dropdownMatchSelectWidth={false}
                              options={sortOrderShops(this.props.order_shops)}
                              style={{ width: "100%" }}
                              onChange={(e) => {
                                const amz = getAmazonValues(this.props.order_shops);
                                const prev = addAmazonGroupIfAll(this.props.orderFilter.order_shops || [], amz);
                                this.filterChange(handleAmazonGroup(e, prev, amz), "order_shops");
                              }}
                              value={addAmazonGroupIfAll(this.props.orderFilter.order_shops || [], getAmazonValues(this.props.order_shops))}
                            />
                          </div>
                        )}
                        <div className="px-1 order-input-container">
                          <InputText
                            type="number"
                            // width={"0.75rem"}
                            number="1"
                            name="id"
                            value={this.props.orderFilter.id}
                            placeholder="Order no."
                            // blockSize="12rem"
                            style={{ width: "100%", fontSize: "14px" }}
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1 order-input-container">
                          <div className="form-group order-input-form-group">
                            <Label className="text-sm-label">
                              {"Order price from - to"}
                            </Label>
                            <div className="d-flex">
                              <InputText
                                type="number"
                                name="total_price_from"
                                placeholder={"From"}
                                hideLabel={true}
                                value={this.props.orderFilter.total_price_from}
                                style={{ width: "100%", fontSize: "14px" }}
                                onKeyDown={this.handleKeyDown}
                                onChange={(e) => this.filterChange(e)}
                              />
                              <InputText
                                type="number"
                                name="total_price_to"
                                placeholder={"To"}
                                hideLabel={true}
                                value={this.props.orderFilter.total_price_to}
                                style={{
                                  width: "100%",
                                  fontSize: "14px",
                                  borderLeftWidth: 0,
                                }}
                                onKeyDown={this.handleKeyDown}
                                onChange={(e) => this.filterChange(e)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="px-1 order-input-container">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="client"
                            placeholder="Client"
                            value={this.props.orderFilter.client}
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="payer"
                            placeholder="Payers"
                            value={this.props.orderFilter.payer}
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="order_row"
                            placeholder="Goods"
                            onKeyDown={this.handleKeyDown}
                            value={this.props.orderFilter.order_row}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1" >
                          <SelectForm
                            placeholder={
                              this.state.paymentGroups?.length
                                ? "Payment group type"
                                : "Method of payment"
                            }
                            mode="multiple"
                            style={{ width: "100%" }}
                            dropdownMatchSelectWidth={false}
                            options={
                              this.state.paymentGroups?.length
                                ? this.state.paymentGroups
                                : this.state.payment_types
                            }
                            onChange={(e) => this.filterChange(e, "payment")}
                            value={this.props.orderFilter.payment}
                          />
                        </div>
                        <div className="px-1">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="payment_reference"
                            placeholder="Payment reference"
                            value={this.props.orderFilter.payment_reference}
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1" style={{ height: "fit-content" }}>
                          <SelectForm
                            placeholder={
                              this.state.carrierGroups?.length
                                ? "Delivery group type"
                                : "Delivery type"
                            }
                            mode="multiple"
                            style={{ width: "100%" }}
                            dropdownMatchSelectWidth={false}
                            options={
                              this.state.carrierGroups?.length
                                ? this.state.carrierGroups
                                : this.state.carriers
                            }
                            onChange={(e) => this.filterChange(e, "delivery")}
                            value={this.props.orderFilter.delivery}
                          />
                        </div>
                        <div className="px-1" style={{ height: "fit-content" }}>
                          <SelectForm
                            placeholder="Created via"
                            dropdownMatchSelectWidth={false}
                            style={{ width: "100%" }}
                            options={[
                              {
                                label: "ALL",
                                value: null,
                              },
                              {
                                label: "PrestaShop",
                                value: "presta",
                              },
                              {
                                label: "Manual",
                                value: "užsakymai",
                              },
                              {
                                label: "Lost cart",
                                value: "lost_cart",
                              },
                            ]}
                            onChange={(e) => this.filterChange(e, "created")}
                            value={this.props.orderFilter.created}
                          />
                        </div>
                        <div className="px-1" style={{ height: "fit-content" }}>
                          <Label className="text-sm-label">
                            Comment statuses
                          </Label>
                          <Select
                            placeholder="Comment statuses"
                            mode="multiple"
                            allowClear
                            dropdownMatchSelectWidth={false}
                            value={
                              this.props.orderFilter.comment_state.map(
                                (item) => item.value
                              ) || undefined
                            }
                            style={{
                              minWidth: 150,
                              width: "100%",
                              maxWidth: 1000,
                              height: "fit-content",
                            }}
                            onChange={(_, arg) =>
                              this.filterChange(arg, "comment_state")
                            }
                            filterOption={(input, option) => {
                              if (option.children) {
                                return (
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                );
                              }
                            }}
                          >
                            {this.state.comment_state.map((comState, index) => {
                              return (
                                <OptGroup
                                  key={`com${index}`}
                                  label={comState.title}
                                >
                                  {comState.children.map(
                                    (com_children, index) => (
                                      <Option
                                        key={`com_children_${com_children.id}_${index}`}
                                        children2={comState.title}
                                        value={com_children.id}
                                      >
                                        {com_children.name}
                                      </Option>
                                    )
                                  )}
                                </OptGroup>
                              );
                            })}
                          </Select>
                        </div>
                        <div className="px-1">
                          <InputText
                            type="number"
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="comment"
                            placeholder="Comment"
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                            value={this.props.orderFilter.comment}
                          />
                        </div>
                        <div className="px-1">
                          <InputText
                            type="number"
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="ean"
                            placeholder="EAN"
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                            value={this.props.orderFilter.ean}
                          />
                        </div>
                        <div className="px-1">
                          <Label className="text-sm-label">{this.state.statusGroups?.length
                            ? "Payment status group"
                            : "Payment status"}</Label>
                          <Select
                            showSearch
                            allowClear
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={
                              this.state.statusGroups?.length ?
                                this.state.statusGroups :
                                this.state.statuses
                                  ?.filter((item) =>
                                    item.label.toLowerCase().includes("payment")
                                  )
                                  ?.reduce((acc, status) => {
                                    const existingStatus = acc.find(
                                      (s) => s.label === status.title
                                    );
                                    if (!existingStatus) {
                                      return [
                                        ...acc,
                                        {
                                          value: status.value,
                                          label: status.title,
                                        },
                                      ];
                                    }
                                    return acc;
                                  }, [])}
                            dropdownMatchSelectWidth={false}
                            style={{ minWidth: 150, maxWidth: 1000, width: '100%' }}
                            placeholder="Payment status"
                            onChange={(e) => {
                              console.log("e:", e);
                              this.filterChange(e, "payment_status");
                            }}
                            value={this.props.orderFilter.payment_status}
                          />
                        </div>
                        <div className="px-1" style={{ height: "fit-content" }}>
                          <Label className="text-sm-label">Invoices sent</Label>
                          <Select
                            options={[
                              { value: "", label: "All" },
                              { value: "not_sent", label: "Not shipped" },
                              {
                                value: "some_sent",
                                label: "Partially shipped",
                              },
                              { value: "all_sent", label: "Shipped" },
                            ]}
                            dropdownMatchSelectWidth={false}
                            allowClear
                            style={{
                              minWidth: 150,
                              width: "100%",
                              maxWidth: 1000,
                              height: "fit-content",
                            }}
                            placeholder="Invoices sent"
                            onChange={(e) =>
                              this.filterChange(e, "invoice_email_state")
                            }
                            value={this.props.orderFilter.invoice_email_state}
                          />
                        </div>
                        <div className="px-1 orders-supplier-filter-container">
                          <div className="form-group order-input-form-group orders-supplier-filter-form-group">
                            <div className="orders-supplier-filter-checkbox-container">
                              <p className="orders-supplier-filter-checkbox-label">
                                Is primary{" "}
                              </p>
                              <Checkbox
                                className="ml-2"
                                checked={
                                  this.props.orderFilter.supplier_is_primary
                                }
                                onChange={(e) =>
                                  this.filterChange(
                                    e.target.checked,
                                    "supplier_is_primary"
                                  )
                                }
                              />
                            </div>
                            <DebounceSelect
                              label="Supplier"
                              labelInValue={true}
                              showSearch={true}
                              includeEmptyOption={true}
                              value={this.props.orderFilter.supplier_id}
                              placeholder={"Type to search"}
                              fetchOptions={this.supplierCodeFetchOptions}
                              onChange={(value) => {
                                this.filterChange(value, "supplier_id");
                              }}
                              className="orders-supplier-filter-select"
                            />
                          </div>
                        </div>
                        <div className="px-1">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="gift_code"
                            placeholder="Discount code"
                            onKeyDown={this.handleKeyDown}
                            value={this.props.orderFilter.gift_code}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-center">
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                Serial number
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={
                                    this.props.orderFilter.serialNumber_check
                                  }
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "serialNumber_check"
                                    )
                                  }
                                />
                                {this.props.orderFilter.serialNumber_check && (
                                  <div className="ml-2">
                                    <Switch
                                      checkedChildren={"S/N"}
                                      unCheckedChildren={"S/N"}
                                      checked={
                                        this.props.orderFilter
                                          .serialNumber_switch
                                      }
                                      onChange={(value) =>
                                        this.filterChange(
                                          value,
                                          "serialNumber_switch"
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>{" "}
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">Invoices</Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={
                                    this.props.orderFilter.assigned_bills_check
                                  }
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "assigned_bills_check"
                                    )
                                  }
                                />
                                {this.props.orderFilter
                                  .assigned_bills_check && (
                                    <div className="ml-2">
                                      <Switch
                                        checkedChildren={"I"}
                                        unCheckedChildren={"0"}
                                        checked={
                                          this.props.orderFilter
                                            .assigned_bills_switch
                                        }
                                        onChange={(value) =>
                                          this.filterChange(
                                            value,
                                            "assigned_bills_switch"
                                          )
                                        }
                                      />
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-center">
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                With errors
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={
                                    this.props.orderFilter.with_errors_check
                                  }
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "with_errors_check"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">Stock Available</Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={this.props.orderFilter.has_stock}
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "has_stock"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-center">
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                Stuck in delivery
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={
                                    this.props.orderFilter.stuck_in_delivery
                                  }
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "stuck_in_delivery"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                Not picked up
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={this.props.orderFilter.not_picked_up}
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "not_picked_up"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-center">
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                Reverse VAT
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={this.props?.orderFilter?.reverse_vat}
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "reverse_vat"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                Auto-Launch Exceptions
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={this.props?.orderFilter?.auto_launch_exceptions}
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "auto_launch_exceptions"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-start justify-content-center">
                          <div className="px-1">
                            <div className="form-group order-checkbox-form-group">
                              <Label className="text-sm-label">
                                Blacklisted
                              </Label>
                              <div
                                className="d-flex justify-content-center mr-2"
                                style={{ fontSize: "0.75rem" }}
                              >
                                <Checkbox
                                  checked={this.props?.orderFilter?.blacklisted}
                                  onChange={(e) =>
                                    this.filterChange(
                                      e.target.checked,
                                      "blacklisted"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="px-1 range-picker-span">
                          <div className="form-group order-input-form-group">
                            <Label className="text-sm-label">
                              Order creation date
                            </Label>
                            <div>
                              <RangePickerComp
                                style={{ width: "100%" }}
                                placeholder={["Start time", "End time"]}
                                value={[
                                  this.getDateFormat(
                                    this.props.orderFilter.date[0]
                                  ),
                                  this.getDateFormat(
                                    this.props.orderFilter.date[1]
                                  ),
                                ]}
                                onChange={(e, args) =>
                                  this.filterChange(args, "date")
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="px-1 range-picker-span">
                          <div className="form-group order-input-form-group">
                            <Label className="text-sm-label">
                              Delivery to client date
                            </Label>
                            <div>
                              <RangePickerComp
                                style={{ width: "100%" }}
                                placeholder={["Start time", "End time"]}
                                disabledDate={() => { }}
                                value={
                                  this.props.orderFilter.client_delivery_date
                                    ? [
                                      this.getDateFormat(
                                        this.props.orderFilter
                                          .client_delivery_date[0]
                                      ),
                                      this.getDateFormat(
                                        this.props.orderFilter
                                          .client_delivery_date[1]
                                      ),
                                    ]
                                    : ["", ""]
                                }
                                onChange={(e, args) =>
                                  this.filterChange(args, "client_delivery_date")
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="px-1 range-picker-span">
                          <div className="form-group order-input-form-group">
                            <Label className="text-sm-label">
                              Ship-out deadline
                            </Label>
                            <div>
                              <RangePickerComp
                                style={{ width: "100%" }}
                                placeholder={["Start time", "End time"]}
                                disabledDate={() => { }}
                                value={
                                  this.props.orderFilter.shipout_deadline
                                    ? [
                                      this.getDateFormat(
                                        this.props.orderFilter
                                          .shipout_deadline[0]
                                      ),
                                      this.getDateFormat(
                                        this.props.orderFilter
                                          .shipout_deadline[1]
                                      ),
                                    ]
                                    : ["", ""]
                                }
                                onChange={(e, args) =>
                                  this.filterChange(args, "shipout_deadline")
                                }
                              />
                            </div>
                          </div>
                        </div>

                        {!onlyFiOrders(this.props.user.id) && (
                          <>
                            <div className="px-1 range-picker-span">
                              <div className="form-group order-input-form-group">
                                <div className="d-flex align-items-center justify-content-between">
                                  <Label className="text-sm-label">
                                    Supplier date
                                  </Label>
                                  <div>
                                    {this.props.orderFilter.supp_date[0] && (
                                      <>
                                        <Tooltip
                                          placement="top"
                                          title="Show with carryings"
                                        >
                                          <Checkbox
                                            checked={
                                              this.props.orderFilter.carrying
                                            }
                                            onChange={(e) =>
                                              this.filterChange(
                                                e.target.checked,
                                                "carrying"
                                              )
                                            }
                                          />
                                        </Tooltip>
                                        <Tooltip
                                          placement="top"
                                          title="Show without shipments"
                                        >
                                          <Checkbox
                                            // className="ml-2"
                                            checked={
                                              this.props.orderFilter
                                                .without_shipping
                                            }
                                            onChange={(e) =>
                                              this.filterChange(
                                                e.target.checked,
                                                "without_shipping"
                                              )
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="range-picker-span">
                                  <RangePickerComp
                                    style={{ width: "100%" }}
                                    placeholder={["Start time", "End time"]}
                                    disabledDate={() => { }}
                                    value={[
                                      this.getDateFormat(
                                        this.props.orderFilter.supp_date[0]
                                      ),
                                      this.getDateFormat(
                                        this.props.orderFilter.supp_date[1]
                                      ),
                                    ]}
                                    onChange={(e, args) =>
                                      this.filterChange(args, "supp_date")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="px-1 range-picker-span">
                          <RangePickerComp
                            label="Shipment date"
                            style={{ width: "100%" }}
                            placeholder={["Start time", "End time"]}
                            disabledDate={() => { }}
                            value={
                              this.props.orderFilter.shipments_created_at
                                ? [
                                  this.getDateFormat(
                                    this.props.orderFilter
                                      .shipments_created_at[0]
                                  ),
                                  this.getDateFormat(
                                    this.props.orderFilter
                                      .shipments_created_at[1]
                                  ),
                                ]
                                : ["", ""]
                            }
                            onChange={(_, args) =>
                              this.filterChange(args, "shipments_created_at")
                            }
                          />
                        </div>
                        {!!this.props.orderFilter.shipments_created_at &&
                          !!this.props.orderFilter.shipments_created_at[0] && (
                            <div
                              className="px-1"
                              style={{
                                height: "fit-content",
                              }}
                            >
                              <SelectInput
                                label="Shipment types"
                                options={[
                                  { value: "", label: "All" },
                                  ...shipment_types_options,
                                ]}
                                dropdownMatchSelectWidth={false}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.filterChange(e, "shipment_type")
                                }
                                value={this.props.orderFilter.shipment_type}
                              />
                            </div>
                          )}
                        <div className="px-1">
                          <div className="form-group order-input-form-group">
                            <InputSwitchComponent
                              label="Product QTY in order"
                              name="product_qty_in_order"
                              options={[
                                {
                                  label: "Unset",
                                  value: "",
                                },
                                {
                                  label: "1",
                                  value: "one",
                                },
                                {
                                  label: "1+",
                                  value: "more",
                                },
                              ]}
                              value={
                                this.props.orderFilter.product_qty_in_order ||
                                ""
                              }
                              onChange={(val) => {
                                this.filterChange(
                                  val.target.value,
                                  "product_qty_in_order"
                                );
                              }}
                            />
                          </div>
                        </div>

                        <div className="px-1">
                          <div className="form-group" style={{ width: "100%" }}>
                            <InputSwitchComponent
                              label="No goods supply"
                              name="no_goods_supply"
                              options={[
                                {
                                  label: "Unset",
                                  value: "",
                                },
                                {
                                  label: "All",
                                  value: "all",
                                },
                                {
                                  label: "1+",
                                  value: "at_least_one",
                                },
                              ]}
                              value={
                                this.props.orderFilter.no_goods_supply || ""
                              }
                              onChange={(val) => {
                                this.filterChange(
                                  val.target.value,
                                  "no_goods_supply"
                                );
                              }}
                            />
                          </div>
                        </div>
                        {this.props.orderFilter.alerts && (
                          <div className="px-1" style={{ height: "fit-content" }}>
                            <Label className="text-sm-label">
                              Alert category
                            </Label>
                            <Select
                              placeholder="All alerts"
                              mode="multiple"
                              allowClear
                              dropdownMatchSelectWidth={false}
                              value={this.props.orderFilter.alert_ids || []}
                              style={{
                                minWidth: 150,
                                width: "100%",
                                maxWidth: 1000,
                                height: "fit-content",
                              }}
                              onChange={(alert_ids) =>
                                this.filterChange(alert_ids, "alert_ids")
                              }
                              filterOption={(input, option) => {
                                if (option.children) {
                                  return (
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  );
                                }
                              }}
                            >
                              {ALERT_ROLES.map((role) => {
                                const rules = this.state.alertRules.filter(
                                  (rule) => rule.role === role.value
                                );
                                if (rules.length === 0) return null;
                                return (
                                  <OptGroup key={role.value} label={role.label}>
                                    {rules.map((rule) => (
                                      <Option key={rule.id} value={rule.id}>
                                        {rule.display_title}
                                      </Option>
                                    ))}
                                  </OptGroup>
                                );
                              })}
                            </Select>
                          </div>
                        )}
                        <div className="urgent-counter-wrapper">
                          <div
                            className="mr-1 cursor-pointer"
                            onClick={this.toggleAlertsFilter}
                            title="Filter orders by alerts"
                          >
                            <span
                              className="filter-order-span"
                              style={{
                                color: this.props.orderFilter.alerts
                                  ? "#17A2B8"
                                  : "#bfbfbf",
                              }}
                            >
                              Alerts
                            </span>
                            <div
                              className="ml-2 text-center filter-orders-active"
                              style={{
                                background: this.props.orderFilter.alerts
                                  ? "#0E7C8C"
                                  : "#17A2B8",
                                boxShadow: this.props.orderFilter.alerts
                                  ? "0 0 0 2px #A7DFE8"
                                  : "none",
                              }}
                            >
                              {this.state.isAlertsLoading ? (
                                <Spin className="custom_spinner" />
                              ) : (
                                this.state.orderAlerts?.length
                              )}
                            </div>
                          </div>
                          <div onClick={() =>
                            this.filterChange(
                              !this.props.orderFilter.urgents,
                              "urgents"
                            )
                          }
                            className="cursor-pointer">
                            <span
                              className="filter-order-span"
                              style={{
                                color: this.props.orderFilter.urgents
                                  ? "#FF0000"
                                  : "#bfbfbf",
                              }}
                            >
                              Urgent
                            </span>
                            <div
                              className="ml-2 text-center filter-orders-active"
                              style={{ background: "#FF0000" }}
                            >
                              {this.props.total_urgent == "loading" ? (
                                <Spin className="custom_spinner" />
                              ) : (
                                this.props.total_urgent
                              )}
                            </div>
                          </div>
                          <div onClick={() =>
                            this.filterChange(
                              !this.props.orderFilter.vips,
                              "vips"
                            )
                          }
                            className="cursor-pointer">
                            <span
                              className="filter-order-span"
                              style={{
                                color: this.props.orderFilter.vips
                                  ? "#FF0000"
                                  : "#bfbfbf",
                              }}
                            >
                              VIP
                            </span>
                            <div
                              className="ml-2 text-center filter-orders-active"
                              style={{ background: "#FF0000" }}
                            >
                              {this.props.total_vip == "loading" ? (
                                <Spin className="custom_spinner" />
                              ) : (
                                this.props.total_vip
                              )}
                            </div>
                          </div>
                        </div>
                        {/*  */}
                        {/* <div className="mx-2 d-flex justify-content-center align-items-center">
                          <span
                            className="filter-order-span"
                            style={{
                              color: this.props.orderFilter.ship_api_errors
                                ? "#F7951E"
                                : "#bfbfbf",
                            }}
                            onClick={() =>
                              this.filterChange(
                                !this.props.orderFilter.ship_api_errors,
                                "ship_api_errors"
                              )
                            }
                          >
                            Ship ERR
                          </span>
                          <div
                            className="ml-2 text-center filter-orders-active"
                            style={{ background: "#F7951E" }}
                          >
                            {this.props.total_shipments_with_error ==
                            "loading" ? (
                              <Spin className="custom_spinner" />
                            ) : (
                              this.props.total_shipments_with_error
                            )}
                          </div>
                        </div>{" "} */}
                      </React.Fragment>
                    </motion.div>
                  )}
                </AnimatePresence>
              </TableFilterBox>
              <div>
                <ContentValidation
                  loader={this.props.loading_orders}
                  array={this.props.orders}
                  alertId_s="ordersAlert-s"
                  alertId_e="ordersAlert-e"
                >
                  <div className="col-12">
                    <div className="row">
                      <div className="col-4 d-flex align-items-center">
                        <small>
                          Selected orders:{" "}
                          <b>{this.state.orders_checked.length}</b>
                        </small>
                        <small>
                          , selected suppliers:{" "}
                          <b>{this.state.supplyings_checked.length}</b>
                        </small>
                        <small>
                          , selected products:{" "}
                          <b>{this.state.order_rows_checked.length}</b>
                        </small>
                      </div>
                      <div className="col-4">
                        {this.state.order_row_type !== "Extra services" && (
                          <Pagination
                            className="mb-0"
                            setPagination={this.setPagination}
                            page={this.props.settings.page}
                            totals={this.props.totals}
                            pageCount={this.props.settings.page_count}
                          />
                        )}
                      </div>
                      <div className="col-4"></div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <OrderTable
                      orders={this.props.orders}
                      selected_orders_full={this.state.orders_checked_full}
                      totals={this.props.totals}
                      showAlerts={!!this.props.orderFilter.alerts}
                      pickedSupplierId={this.props?.orderFilter?.supplier_id}
                      layoutOfTableIncl={(val) => {
                        if (val == "Vadyba" && onlyFiOrders(this.props.user.id))
                          return false;
                        return this.state.layoutOfTable.includes(val);
                      }}
                      handleCheck={this.handleCheck}
                      onEdit={this.onEdit}
                      orders_checked={this.state.orders_checked}
                      handleSelected={this.handleSelected}
                      //
                      updateSerialNumber={this.props.updateSerialNumber}
                      order_row_type={this.state.order_row_type}
                      reload_for_bulk_shipments={
                        this.state.reload_for_bulk_shipments
                      }
                      changeTableType={
                        onlyFiOrders(this.props.user.id)
                          ? null
                          : (val) => {
                            this.setState(
                              {
                                order_row_type: val,
                              },
                              () => {
                                if (
                                  this.state.order_row_type ==
                                  "Extra services" &&
                                  typeof this.props.loading_orders ==
                                  "boolean" &&
                                  !this.props.loading_orders &&
                                  this.state.orders_checked &&
                                  this.state.orders_checked.length == 0 &&
                                  !this.props.loading_orders &&
                                  !!this.props.user.user_suppliers?.length &&
                                  this.props.orders.length > 0
                                ) {
                                  this.checkSupplyingsByUserSuppliers();
                                } else {
                                  this.bulkDataSetter();
                                }
                              }
                            );
                          }
                      }
                      supp_date={this.props.orderFilter.supp_date}
                    />
                    {this.state.order_row_type !== "Extra services" && (
                      <Pagination
                        setPagination={this.setPagination}
                        page={this.props.settings.page}
                        totals={this.props.totals}
                        pageCount={this.props.settings.page_count}
                      />
                    )}
                  </div>
                </ContentValidation>
              </div>
            </ContentBlock>
          </>
          <div id="modal-roots" />
          <RegularModal
            ref={this.modalRef}
            layoutOfTable={this.state.layoutOfTable}
            layoutOfTablesFunc={this.tableColumnSelector}
            avalaibleStatus={this.state.statuses}
            comments_state_all={this.state.comments_state_all}
            payment_types={this.state.payment_types}
            carriers={this.state.carriers}
          />
          <ModalBulkActionPreviewHistory
            active={this.state.modal_bulk_action_preview}
            closeModal={() =>
              this.setState({
                modal_bulk_action_preview: false,
              })
            }
            openOrder={(id) => this.onEdit(null, id)}
          />
        </Container>
        <OrdersAlertsModal
          visible={this.state.isAlertModalVisible}
          onCancel={this.closeAlertModal}
          alerts={this.state.orderAlerts}
          refreshAlerts={this.fetchOrderAlerts}
          onEdit={this.onEdit}
        />
        {this.state.orderAlerts?.length > 0 && this.state.showAlertMessage && (
          <div className="order-alert-alerts-message">
            <div className="order-alert-message-container">
              <AiFillInfoCircle color="#1890FF" size={14} />
              <p className="order-alert-message-text">
                You have new{" "}
                {
                  this.state.orderAlerts?.filter((alert) => !alert.seen_at)
                    ?.length
                }{" "}
                alerts
              </p>
            </div>
            <p
              className="order-alert-preview-link"
              onClick={() =>
                this.openAlertModal([
                  {
                    type: "Success",
                    message: "Order processed successfully",
                  },
                ])
              }
            >
              Preview
            </p>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  // Pagr order
  user: state.auth.user,
  orders: state.orders.orders,
  totals: state.orders.totals,
  total_amount: state.orders.total_amount,
  total_urgent: state.orders.total_urgent,
  total_vip: state.orders.total_vip,
  total_invoices_with_error: state.orders.total_invoices_with_error,
  total_shipments_with_error: state.orders.total_shipments_with_error,
  loading_orders: state.orders.loading_orders,
  order_shops: state.options.order_shops,
  orderFilter: state.filters.orders,
  settings: state.orders.settings,
});
export default connect(mapStateToProps, {
  getOrders,
  getOrder,
  updateSerialNumber,
  resetOrdersFilter,
  setOrdersFilters,
  valueOrdersFilter,
  valueMultiOrdersFilter,
  setOrderSettings,
  orderBulkByIds,
  getOrderInitials,
  setCountriesOptions,
  setPickupAddressesOptions,
})(AcceptedOrders);

const ExportDropdown = ({
  cleanUp,
  orderFilter,
  user,
  settings,
  orders_checked,
  supplyings_checked,
  total_amount,
}) => {
  const dispatch = useDispatch();
  const [openDropdown, setOpenDropdown] = useState(false);
  const exportContracts = (action) => {
    let url;
    let checked;
    let fileTitle = "Orders.xlsx";
    if (action == "selected") {
      url = "/api/v1/orders/export_orders_in_excel/";
      checked = orders_checked;
    } else if (action == "all") {
      url = `/api/v1/orders/export_orders_in_excel?${settings.params_filter}`;
      checked = [];
    } else if (action == "order_rows") {
      url = "/api/v1/orders/export_order_rows_in_csv";
      checked = supplyings_checked;
      fileTitle = "Goods_suppliers.csv";
    } else if (action == "unsent_csv") {
      url = `/api/v1/orders/export_order_unsended_csv?${settings.params_filter}`;
      checked = supplyings_checked;
      fileTitle = "orders_unsent.csv";
    }

    exportDocument(url, fileTitle, "POST", {
      checked,
    });
  };

  const items = [
    {
      key: "1",
      label: (
        <div
          onClick={() => {
            if (!orders_checked.length) return antdMessageError("Not selected");
            exportContracts("selected");
          }}
        >
          Export selected
        </div>
      ),
    },
    {
      key: "2",
      label: <div onClick={() => exportContracts("all")}>Export filtered</div>,
    },
    {
      key: "2-3",
      label: (
        <div onClick={() => exportContracts("order_rows")}>
          Export suppliers
        </div>
      ),
    },

    {
      key: "3",
      label: (
        <div onClick={() => exportContracts("unsent_csv")}>Export unsent</div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "4",
      label: (
        <div
          onClick={() => {
            if (supplyings_checked.length == 0)
              return antdMessageError("Not selected");
            confirm({
              title: "Are you sure?",
              icon: <ExclamationCircleOutlined className="text-primary" />,
              content: "You will not be able to undo this action",
              onOk: () => {
                postTrRequests({
                  checked: supplyings_checked,
                }).then((res) => {
                  if (res.success) {
                    cleanUp();
                  }
                });
                console.log("OK");
              },
              onCancel() {
                console.log("Cancel");
              },
            });
          }}
        >
          Export selected to TR request
        </div>
      ),
    },
    {
      key: "5",
      label: (
        <div
          onClick={() => {
            if (total_amount ? total_amount > 300 : false)
              return antdMessageError("To many orders");
            confirm({
              title: "Are you sure?",
              icon: <ExclamationCircleOutlined className="text-primary" />,
              content: "You will not be able to undo this action",
              onOk: () => {
                postTrRequests({
                  filters: settings.params_filter + "&filter=1",
                }).then((res) => {
                  if (res.success) {
                    console.log("Successfully");
                  }
                });
                console.log("OK");
              },
              onCancel() {
                console.log("Cancel");
              },
            });
          }}
        >
          Export filtered to TR request
        </div>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "6",
      label: (
        <div
          onClick={() => {
            if (
              !orderFilter.shipments_created_at ||
              !orderFilter.shipments_created_at[0]
            )
              return antdMessageError(
                "Select a 'Shipment date' using the filters"
              );
            confirm({
              title: "Are you sure?",
              icon: <ExclamationCircleOutlined className="text-primary" />,
              content: "You will not be able to undo this action",
              onOk: () => {
                dispatch(callGenerateShipmentXlsx());
              },
              onCancel() {
                console.log("Cancel");
              },
            });
          }}
        >
          Generate shipment XLSX
        </div>
      ),
    },
    openDropdown && {
      key: "7",
      label: <GenerateShipmentXlsx user_id={user.id} />,
    },
  ];

  return (
    <>
      <Dropdown
        arrow={true}
        trigger="click"
        open={openDropdown}
        onOpenChange={(event) => {
          setOpenDropdown(event);
          console.log({ event });
        }}
        menu={{ items }}
        placement="bottomRight"
      >
        <button
          className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
          type="button"
        >
          Export
        </button>
      </Dropdown>
    </>
  );
};

const GenerateShipmentXlsx = ({ user_id }) => {
  const dispatch = useDispatch();
  const { loading, value, setReFetch } = useFetch(
    `/api/v1/settings?log_item=shipments_xlsx_${user_id}`
  );
  if (loading)
    return (
      <div className="text-center">
        <Spin />
      </div>
    );

  if (!value?.data?.updated_at) return null;

  if (value?.data?.body == "generating")
    return (
      <div className="text-silver">
        <Spin size="small" /> Generating shipment XLSX
      </div>
    );

  return (
    <div
      onClick={() => {
        dispatch(
          exportedDocumentAction({
            name: `shipments_xlsx_${user_id}.xlsx`,
            api_url: "/api/v1/downloads",
          })
        ).then(() => setReFetch());
      }}
    >
      Download your last generated shipment XLSX <br />(
      {prettyDateFormat(value.data.updated_at)})
    </div>
  );
};
